export default __webpack_public_path__ + "88b5ddd32e32ae4bd08843e9b03af203.woff2";